import { useMutation } from '@tanstack/react-query';
import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { accountService } from '../services/userUpdate.service';

export const useUpdateUserData = () => {
  const {
    mutate: updateUserData,
    isLoading,
    error,
    isError
  } = useMutation({
    mutationFn: (data: UpdateUserDataRequestTypes) => accountService.updateUserData(data)
  });

  return {
    updateUserData,
    isUpdating: isLoading,
    updateError: error,
    hasUpdateError: isError
  };
};
